const Position = ({ text }) => {
  const base =
    'uppercase text-bodyMobile md:text-subheadingTeamCardDesktop text-khaki font-chivoMono'

  return <span className={base}>{text}</span>
}

export default Position
